export enum TipoNotificacao {
    MudancaAtributoRfb = "MudancaAtributoRfb",
    ProcessamentoImportacaoProdutos = "ProcessamentoImportacaoProdutos",
    ProcessamentoImportacaoOperadores = "ProcessamentoImportacaoOperadores",
    ProcessamentoSugestaoPreenchimentoSaneamento = "ProcessamentoSugestaoPreenchimentoSaneamento",
    ProcessamentoImportacaoPreenchimentoSaneamento = "ProcessamentoImportacaoPreenchimentoSaneamento",
    ProcessamentoExportacaoPreenchimentoSaneamento = "ProcessamentoExportacaoPreenchimentoSaneamento",
    ProcessamentoExportacaoProdutos = "ProcessamentoExportacaoProdutos",
    ProcessamentoExportacaoOperadoresEstrangeiros = "ProcessamentoExportacaoOperadoresEstrangeiros",
    ProcessamentoExportacaoProdutoVersoes = "ProcessamentoExportacaoProdutoVersoes",
    ProcessamentoCapturaProdutosPortalUnico = "ProcessamentoCapturaProdutosPortalUnico",
    ProcessamentoCapturaFabricantesPortalUnico = "ProcessamentoCapturaFabricantesPortalUnico",
    ProcessamentoCapturaOperadoresEstrangeirosPortalUnico = "ProcessamentoCapturaOperadoresEstrangeirosPortalUnico",
    ProcessamentoExportacaoRelatorio = "ProcessamentoExportacaoRelatorio",
    ProcessamentoExportacaoAtributosModificados = "ProcessamentoExportacaoAtributosModificados",
    ProcessamentoAdicionarEmpresa = "ProcessamentoAdicionarEmpresa",
    ProcessamentoImportacaoSaneamentoAuditoria = "ProcessamentoImportacaoSaneamentoAuditoria",
    ProcessamentoExportacaoSaneamentoAuditoria = "ProcessamentoExportacaoSaneamentoAuditoria",
}
